import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const athlon = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      hero: {
        title: "<strong>{{organization}}<br>Werkstatt-Buchung</strong>",
        subtitle: null,
      },
      welcomeModal: {
        title: "Sie verlassen nun die Seite von Athlon",
        text: "Bitte beachten Sie, dass Sie sich auf einer Website befinden, für deren Inhalt Athlon nicht verantwortlich ist und die Datenschutzbestimmungen von Athlon keine Anwendung finden.",
      },
      layout: {
        backText: "Zurück zu athlon.com",
      },
      benefits: {
        "bullet-point-3": "",
        feedbackTitle: "Feedback",
      },
      garageList: {
        ...de_DE_formal.translation.garageList,
        filters: {
          premiumServices: {
            ...de_DE_formal.translation.garageList.filters.premiumServices,
            "additional-cost-info":
              "*Anfallende Kosten für Ersatzfahrzeuge sind kein Vertragsbestandteil.",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/athlon",
      chooseSubServices: "Sollen weitere Services erledigt werden?",
      contact: {
        title: "Kontakt",
        text: "Bestehen noch Fragen zur Buchung? Wir kümmern uns gerne persönlich um Ihr Anliegen.",
        "partner-text": "Technischer Service {{organization}}",
        email: {
          label: "E-Mail",
          link: "mailto:werkstattmeister@repareo.de",
          title: "werkstattmeister@repareo.de",
        },
        phone: {
          label: "Telefon",
          link: "tel:004989244182010",
          title: "+49 89 244 182 010",
        },
      },
    },
  },
};
